import { UploadTemplatesAdmin } from "@/features/admin/UploadTemplatesAdmin";
import { useAppShell } from "@/shell/app-shell-context";

export function UploadTemplatesRoute() {
  const { token } = useAppShell();
  return <UploadTemplatesAdmin token={token} />;
}
